import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

import { PriceText } from '../../../../../../visitSettlement/shared/price/PriceText';

export const StyledPaidAmountText = styled(PriceText)`
   color: ${(props) => props.theme.placeholder};
`;

StyledPaidAmountText.displayName = 'StyledPaidAmountText';

export const StyledRequiredAmountText = styled(PriceText)`
   color: ${(props) => props.theme.placeholder};
`;

StyledRequiredAmountText.displayName = 'StyledRequiredAmountText';

export const StyledAmountWrapper = styled(StyledFlex)`
   flex-shrink: 0;
`;

StyledAmountWrapper.displayName = 'StyledAmountWrapper';
